import icon from 'assets/img/icons/special-offers.svg';
import useActiveItem from 'hooks/useActiveItem';
import useProfile from 'hooks/useProfile';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { createAPI } from 'services/api/api';
import { setRefreshTrigger } from 'store/cards';
import { editUser, setError } from 'store/user';

const PurchaseWindowConfirm = ({ currentQuantity, nextStep, setCardPackId, close }) => {
  const api = createAPI();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const {balance} = useProfile();
  const { activeItem} = useActiveItem();
  const {id, marketplace_id, tier } = activeItem;
  const [isLoading, setIsLoading] = useState();


  const confirmRequest = (id) => {
    setIsLoading(true);

    const getEndpoints = () => {
      if (pathname.includes('/buypacks')) {
        return `/card_series/${id}/buy`
      } else {
        return `/marketplace_listing/${marketplace_id}/buy`
      }
    }

    const config = {
      method: 'POST',
    };

    if (pathname.includes('/buypacks')) {
      config.data = {
        payment_method: "balance",
        quantity: currentQuantity,
        tier: tier,
      };
    }

    api(getEndpoints(), config)
      .then((res) => {
        setIsLoading(false);
        nextStep('success');
        dispatch(editUser({field: 'balance', value: balance - (Number(activeItem.cost) * currentQuantity)}));
        setCardPackId(res.data.cardpack_id);
        if (Cookies.get('isBuyFromMarket')) {
          Cookies.remove('isBuyFromMarket');
          dispatch(setRefreshTrigger())
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch(setError(error.message))
        nextStep('fail');
      })
  }

  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Confirmation of payment</h5>
        <p className="modal-window__info">Do you want to use your account balance?</p>
      </header>
      <footer className="modal-window__footer">
        {!isLoading && <button className="modal-window__footer-close" onClick={close}>Cancel</button>}
        <button className={`modal-window__footer-submit ${isLoading ? 'loading' : ''}`} disabled={isLoading} onClick={() => confirmRequest(id)}>Confirm</button>
      </footer>
    </>
  )
}

export default PurchaseWindowConfirm;
